export { onRender } from './render';

//# sourceMappingURL=index.js.map